import {
  GET_USER_REQUEST,
  GET_ALL_USERS,
  GET_USER_INFO,
  ACTIVATE_USER,
  UPDATE_USER_DETAIL,
  DEACTIVATE_USER,
  DELETE_USER,
  APPROVE_USER_REQUEST,
  REJECT_USER_REQUEST,
  UPDATE_REGISTRATION_REQUEST,
  GET_ALL_CM,
  REQUEST_RESET_PASSWORD_EMAIL,
  UPDATE_COMMITTEE_PERMISSIONS
} from "./actions.type";
import ApiService from "../common/apiService";
import constants from "../common/constants";
import {buildDefinitionList} from "../common/tableFunctions";

const UserRequestModule = {
  state: {
    /**
     * Pending cases
     */
    registrations:[],
    currentRegistrations:{},
    profileChanges: [],
    currentProfileChanges:{},
    /**
     * Users and Pagination
     */
    users: [],
    currentUsers:[],
    total: 0,
    page: 1,
    perPage: 20,
    isUsersServerPaginated: false,
    usersSearchTerm: '',
    /**
     * Selected user and user info
     */
    currentUser:{},
    currentRoles:[],
    accessDetails:[],
    facilityPrimaryAr:[],
    selectedSites:[],
    committees:[],
    committeePermissions: {
      write: 0
    },
    subscriptions:[],
    /**
     * Users list for new committee
     */
    usersListForNewCommittee:[]
  },
  mutations: {
    SET_USERS(state,users)
    {
      state.users = users;
      state.total = users.length;
      state.isUsersServerPaginated = false;
    },
    SET_USERS_PAGINATED(state,payload)
    {
      state.users = payload.data || [];
      state.currentUsers = payload.data || [];
      state.total = payload.total || 0;
      state.page = parseInt(payload.current_page || 1, 10);
      state.perPage = parseInt(payload.per_page || state.perPage, 10);
      state.isUsersServerPaginated = true;
    },
    SET_USERS_FOR_NEW_COMMITTEE(state,users)
    {
      let userList = [];
      users.forEach((user) => {
        let u = {};
        u.label = user.first_name + ' ' + user.last_name;
        u.value = user.id;
        userList.push(u)
      });
      state.usersListForNewCommittee = userList;
    },
    SET_USERS_PAGE(state,page){
      state.page = page
    },
    SET_USERS_PER_PAGE(state,perPage){
      state.perPage = perPage;
    },
    SET_USERS_SEARCH_TERM(state, searchTerm) {
      state.usersSearchTerm = searchTerm;
    },
    SET_CURRENT_USERS(state){
      if (state.isUsersServerPaginated) {
        state.currentUsers = state.users;
        return;
      }
      let first = (state.page-1) * state.perPage;
      let last = state.page * state.perPage;
      state.currentUsers = state.users.slice(first,last);
    },
    SET_CURRENT_USER(state,user_id){
      let user = JSON.parse(JSON.stringify(state.users.find(el => el.id == user_id)));
      state.currentUser = user;
    },
    SET_CURRENT_ROLES(state){
      state.currentRoles = state.currentUser.roles.map(el => el.name);
    },
    SET_ACCESS_DETAIL(state,sites){
      state.selectedSites = getSelectedSitesToEdit(sites);
      const res = mapSiteInforForUi(sites);
      state.accessDetails = res.facilities;
      state.facilitiesPrimaryAr = res.facilitiesPrimaryAr;
    },
    SET_COMMITTEES(state,committees){
      let coms = [];
      coms['Committees'] = committees.map(el => el.name).join(',');
      state.committees = buildDefinitionList(coms);
    },
    SET_COMMITTEE_PERMISSIONS(state, committeePermissions){
      if (committeePermissions != null) {
        state.committeePermissions.write = committeePermissions.write;
      } else {
        state.committeePermissions.write = 0;
      }
    },
    SET_SUBSCRIPTIONS(state,subscriptions){
      state.subscriptions = subscriptions;
    },
    SET_REGISTRATION_REQUEST(state,request)
    {
      let regs = request.filter(el => el.type === 'create');
      for(let i in regs)
      {
        let name = {};
        let roles = {};
        let temp = [];

        name.value = regs[i].user.first_name + ' ' + regs[i].user.last_name;
        name.link = '/admin/pending-registration/'+regs[i].id;
        for(let j in regs[i].user.roles)
        {
          const match = constants.USER_ROLES.find(r => r.name === regs[i].user.roles[j].name);
          let name = match ? match.fullName : regs[i].user.roles[j].name;
          temp.push(name);
        }
        regs[i].name = name;
        roles.value = temp.join(',');
        regs[i].role = roles;
      }
      state.registrations = regs;
    },
    SET_PROFILE_CHANGE_REQUEST(state,request)
    {
      let regs = request.filter(el => el.type === 'update' && el.user !== null && el.user.activated === 1);
      for(let i in regs)
      {
        let name = {};
        let roles = {};
        let requests = {};
        let temp = [];
        name.value = regs[i].user.first_name + ' ' + regs[i].user.last_name;
        name.link = '/admin/pending-profile-change/'+regs[i].id;
        for(let j in regs[i].user.roles)
        {
          const match = constants.USER_ROLES.find(r => r.name === regs[i].user.roles[j].name);
          let name = match ? match.fullName : regs[i].user.roles[j].name;
          temp.push(name);
        }
        let properties = Object.keys(regs[i].data);
        const propList = [];
        for(let ii in properties){
          if('user_info' == properties[ii]) {
            const csvInfo = regs[i].data.user_info.csv_info;
            if(csvInfo.emails) {
              propList.push('Email');
            }
            if(csvInfo.phones) {
              propList.push('Phone');
            }
            if(csvInfo.addresses) {
              propList.push('Address');
            }
          }else
            propList.push((properties[ii].charAt(0).toUpperCase() + properties[ii].slice(1)).replace("_"," "));
        }
        requests.value = propList.join(', ');
        regs[i].name = name;
        roles.value = temp.join(', ');
        regs[i].role = roles;
        regs[i].request = requests;
      }
      state.profileChanges = regs;
    },
    SET_CURRENT_REGISTRATION(state,id){
      state.currentRegistrations =  JSON.parse(state.registrations.filter(el => el.id == id)[0].value);
    }
  },
  actions: {
    async [GET_USER_REQUEST](context, payload) {
      let res = false;
      await ApiService.get(`/user-requests?current_role=${localStorage.getItem(constants.CURRENT_ROLE)}`).then(response => {
        res = response.data;
        context.commit('SET_REGISTRATION_REQUEST',res.data)
        context.commit('SET_PROFILE_CHANGE_REQUEST',res.data)
      }).catch(error => {
        res = false;
      });
      return res;
    },
    async [GET_ALL_USERS](context,payload) {
      let res = false;
      const options = payload || {};
      const usePagination = !!options.paginated;
      const page = parseInt(options.page || context.state.page, 10);
      const perPage = parseInt(options.perPage || context.state.perPage, 10);
      const searchTerm = typeof options.search === 'string'
        ? options.search.trim().replace(/\s+/g, ' ')
        : context.state.usersSearchTerm;
      context.commit('SET_USERS_SEARCH_TERM', searchTerm);
      // If current_role is TA_ADMIN then we need to fetch only TA Users.
      let url = '/users';
      if(localStorage.getItem(constants.CURRENT_ROLE) == constants.NATA_ROLE_TA_ADMIN) {
        url = url + '?role=TA';
      }else if(localStorage.getItem(constants.CURRENT_ROLE) == constants.NATA_ROLE_ADMIN) {
        url = url + '?role=NONTA';
      }
      if (searchTerm.length > 0) {
        url = url + (url.indexOf('?') === -1 ? '?' : '&');
        url = url + 'search=' + encodeURIComponent(searchTerm);
      }
      if (usePagination) {
        url = url + (url.indexOf('?') === -1 ? '?' : '&');
        url = url + 'paginate=1&page=' + (isNaN(page) ? 1 : page) + '&per_page=' + (isNaN(perPage) ? 20 : perPage);
      }
      await ApiService.get(url).then(response => {
        res = response.data;
        if (usePagination && res.data && Array.isArray(res.data.data) && res.data.total !== undefined) {
          context.commit('SET_USERS_PAGINATED',res.data);
        } else {
          context.commit('SET_USERS',res.data);
          context.commit('SET_CURRENT_USERS');
        }
      }).catch(error => {
        res = false;
      });
      return res;
    },
    async [GET_ALL_CM](context,payload) {
      let res = false;
      await ApiService.get('/users?role=CM').then(response => {
        res = response.data;
        context.commit('SET_USERS_FOR_NEW_COMMITTEE',res.data);
      }).catch(error => {
        res = false;
      });
      return res;
    },
    async [GET_USER_INFO] (context,payload) {
      let res = false;
      await ApiService.get('/users/'+payload).then(response => {
        res = response.data;
        context.commit('SET_ACCESS_DETAIL',res.data.sites)
        context.commit('SET_COMMITTEES',res.data.committees)
        context.commit('SET_COMMITTEE_PERMISSIONS',res.data.committeePermission);
        context.commit('SET_SUBSCRIPTIONS',res.data.subscriptions);
      }).catch(error => {
        res = false;
      });
      return res;
    },
    async [ACTIVATE_USER] (context,user_id) {
      let res = false;
      await ApiService.post('/activate/'+user_id).then(response => {
        res = response.data
      });
      return res;
    },
    async [DEACTIVATE_USER] (context,user_id) {
      let res = false;
      await ApiService.post('/deactivate/'+user_id).then(response => {
        res = response.data
      });
      return res;
    },
    async [APPROVE_USER_REQUEST] (context, payload){
      let res = false;
      await ApiService.put('/user-requests/'+payload[0],payload[1]).then(response => {
        res = response.data
      });
      return res;
    },
    async [REJECT_USER_REQUEST] (context, payload){
      let res = false;
      await ApiService.put('/user-requests/'+payload[0],payload[1]).then(response => {
        res = response.data
      });
      return res;
    },
    async [UPDATE_REGISTRATION_REQUEST] (context,payload){
      let res = false;
      let params = {
        type:'create',
        value:payload[1]
      };
      await ApiService.put('/user-requests/'+payload[0],params).then(response => {
        res = response.data
      });
      return res;
    },
    async [UPDATE_USER_DETAIL] (context,payload){
      let res = false;
      await ApiService.put('/users/'+payload[0],payload[1]).then(response => {
        res = response.data
      });
      return res;
    },
    async [UPDATE_COMMITTEE_PERMISSIONS] (context,payload){
      let res = false;
      await ApiService.put('/committeepermissions/'+payload[0],payload[1]).then(response => {
        res = response.data
      });
      return res;
    },
    async [DELETE_USER] (context,payload){
      let res = false;
      await ApiService.delete('/users/'+payload).then(response => {
        res = response.data
      });
      return res;
    },
    async [REQUEST_RESET_PASSWORD_EMAIL] (context,payload){
      let res = true;
      await ApiService.post('/user-requests-reset-password',{email:payload}).then(response => {
        res = response.data
      });
      return res;
    },
    updateUsersPage(context,page){
      const nextPage = parseInt(page, 10);
      if (isNaN(nextPage) || nextPage < 1) {
        return;
      }
      if (context.state.isUsersServerPaginated) {
        if (nextPage === parseInt(context.state.page, 10)) {
          return;
        }
        return context.dispatch(GET_ALL_USERS, {
          paginated: true,
          page: nextPage,
          perPage: context.state.perPage,
          search: context.state.usersSearchTerm
        });
      }
      context.commit('SET_USERS_PAGE',nextPage);
      context.commit('SET_CURRENT_USERS');
    },
    updateUsersPerPage(context,perPage){
      const nextPerPage = parseInt(perPage, 10);
      if (isNaN(nextPerPage) || nextPerPage < 1) {
        return;
      }
      if (context.state.isUsersServerPaginated) {
        if (nextPerPage === parseInt(context.state.perPage, 10)) {
          return;
        }
        return context.dispatch(GET_ALL_USERS, {
          paginated: true,
          page: 1,
          perPage: nextPerPage,
          search: context.state.usersSearchTerm
        });
      }
      context.commit('SET_USERS_PER_PAGE',nextPerPage);
      context.commit('SET_CURRENT_USERS');
    },
    updateCurrentUser(context,user_id){
      context.commit('SET_CURRENT_USER',user_id);
      context.commit('SET_CURRENT_ROLES');
    },
    updateCurrentRegistration(context,id){
      context.commit('SET_CURRENT_REGISTRATION',id);
    }
  }
};
const mapSiteInforForUi = (temp) => {
  let result = getSelectedSitesToView(temp);
  let facilitiesPrimaryAr = [];
  let facilities = [];
    for(let j in result)
    {
      let temp = [];
      temp['Facility Accreditation Number*'] = result[j].facility_number;
      temp['Facility Name*'] = result[j].facility_name;
      temp['Site Number and Site Name'] = result[j].sites.join(',');
      facilities.push(buildDefinitionList(temp));
      facilitiesPrimaryAr.push({
        facilityId: result[j].facilityId,
        facilityPrimaryArId: result[j].facilityPrimaryArId,
        facilityMappedPrimaryAr: result[j].facilityMappedPrimaryAr
      })
    }
    return {facilities, facilitiesPrimaryAr};
}
const getSelectedSitesToView = (temp) => {
  let result = [];
  for(let i in temp)
  {
    let site = temp[i].site_number + '-'+ temp[i].name;
    if(result.find(el => el.facility_number == temp[i].facility.facility_number))
    {
      result.find(el => el.facility_number == temp[i].facility.facility_number).sites.push(site)
    }else{
      let f = {};
      f.sites = [];
      f.facility_number = temp[i].facility.facility_number;
      f.facility_name = temp[i].facility.name;
      f.facilityId = temp[i].facility.id;
      f.facilityPrimaryArId = temp[i].facility.primary_ar;
      f.facilityMappedPrimaryAr = temp[i].facility.mapped_primary_ar;
      f.sites.push(site);
      result.push(f);
    }
  }
  return result;
}
  const getSelectedSitesToEdit = (temp) => {
    let result = [];
    for(let i in temp)
    {
      if(result.find(el => el.facility_number == temp[i].facility.facility_number))
      {
        result.find(el => el.facility_number == temp[i].facility.facility_number).sites.push(temp[i]);
      }else{
        let f = {};
        f.sites = [];
        f.facility_number = temp[i].facility.facility_number;
        f.facility_name = temp[i].facility.name;
        f.sites.push(temp[i]);
        result.push(f);
      }
    }
    return result;
}

export default UserRequestModule;
